"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lavarone": {
    "b11cffeb": [{
      "hkey": "2f808557",
      "slug": "bertoldi-lanzino",
      "name": "Bertoldi-Lanzino",
      "primary": true,
      "skipSearch": false
    }],
    "bertoldi": [{
      "hkey": "2f808557",
      "slug": "bertoldi-lanzino",
      "name": "Bertoldi-Lanzino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eaec5e2d": [{
      "hkey": "588e3f55",
      "slug": "gionghi-cappella",
      "name": "Gionghi-Cappella",
      "primary": true,
      "skipSearch": false
    }],
    "cappella": [{
      "hkey": "588e3f55",
      "slug": "gionghi-cappella",
      "name": "Gionghi-Cappella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lavarone"
    }],
    "804a1c1d": [{
      "hkey": "a1a5370f",
      "slug": "chiesa",
      "name": "Chiesa",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa-di-lavarone": [{
      "hkey": "a1a5370f",
      "slug": "chiesa",
      "name": "Chiesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "38a5c8b4": [{
      "hkey": "588e3f55",
      "slug": "gionghi-cappella",
      "name": "Gionghi-Cappella",
      "primary": true,
      "skipSearch": false
    }],
    "gionghi": [{
      "hkey": "588e3f55",
      "slug": "gionghi-cappella",
      "name": "Gionghi-Cappella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lavarone"
    }]
  }
};
exports["default"] = _default;